import { useEffect } from 'react';
import '../App.css';
import * as Forms from '../slices/formsSlice';
import * as User from '../slices/userSlice';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlassLocation } from '@fortawesome/free-solid-svg-icons';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { handleScroll, filterSchemesByDeveloper, filterSitesByDeveloper, filterDevelopersBySiteOrScheme, doFormOnChange, getFormValueWithId, getFormValidWithId, getFormMessageWithId, getAddressListWithId, getPostcodeAddresses, selectAddress } from '../utilities';

const InstructPurchase = () => {
	const dispatch = useAppDispatch();
	const forms = useAppSelector(state => state.forms);
	const introducer = useAppSelector(state => state.user.introducer);
	const ifid = "IF";

	const filteredSchemes = filterSchemesByDeveloper(ifid);
	const filteredSites = filterSitesByDeveloper(ifid);
	const filteredDevelopers = filterDevelopersBySiteOrScheme(ifid);

	useEffect(() => {
		if (filteredSchemes.length == 1) {
			dispatch(Forms.setFormValueWithId({ form: ifid, type: 'select-one', id: "quote_scheme_id", val: filteredSchemes[0].schemeid }));
		}
	}, [filteredSchemes.length, filteredSchemes[0]]);

	useEffect(() => {
		if (filteredDevelopers.length == 1) {
			dispatch(Forms.setFormValueWithId({ form: ifid, type: 'select-one', id: "quote_developer_id", val: filteredDevelopers[0].developerid }));
		}
	}, [filteredDevelopers.length, filteredDevelopers[0]]);

	useEffect(() => {
		setTimeout(() => {
			dispatch(Forms.setFormValueWithId({ form: ifid, type: 'select-one', id: "quote_introducer_id", val: introducer.introducerid }));
		}, 500);
	}, []);

	return (
		<div id='IF' style={{ color: 'black' }}>
			<div id="IFScroll" style={{ overflowY: 'scroll', height: 'calc(100vh - 321px)' }} onScroll={handleScroll}>
				<div style={{ maxWidth: 1280, margin: 'auto', padding: 16 }}>
					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Purchase Type</div>
						<div className='row50'>
							<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "quote_property_type") ? undefined : 'error'} value={getFormValueWithId(ifid, "quote_property_type")} name='quote_property_type' onChange={(e) => doFormOnChange(e)}>
								<option value=''>Please Select...</option>
								<option value='new_build'>New Build</option>
								<option value='standard'>Standard Purchase</option>
							</select>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Property Department:</div>
						<div className='row50'>
							<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "quote_property_department") ? undefined : 'error'} value={getFormValueWithId(ifid, "quote_property_department")} name='quote_property_department' onChange={(e) => doFormOnChange(e)}>
								<option value=''>Please select...</option>
								<option value='New Build'>New Build</option>
								<option value='Residential'>Residential</option>
								<option value='Secured Lending'>Secured Lending</option>
							</select>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Purchase Price £</div>
						<div className='row50'>
							<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "quote_property_price") ? undefined : 'error'} type='number' value={getFormValueWithId(ifid, "quote_property_price")} name='quote_property_price' min='0' onChange={(e) => doFormOnChange(e)} />
						</div>
					</div>

					<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Purchase Property Details</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Introducer:</div>
						<div className='row50'>
							<select data-form-id={ifid} disabled={true} value={getFormValueWithId(ifid, "quote_introducer_id")} name='quote_introducer_id' onChange={(e) => doFormOnChange(e)}>
								<option key={introducer.introducerid} value={introducer.introducerid}> {introducer.introducer} ({introducer.introducerid})</option>
							</select>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Site:</div>
						<div className='row50'>
							<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "quote_site_id") ? undefined : 'error'} value={getFormValueWithId(ifid, "quote_site_id")} name='quote_site_id' onChange={(e) => doFormOnChange(e)}>
								<option value=''>Please Select...</option>

								{(filteredSites || []).map((item: User.sitesState) => {
									return (
										<option key={item.siteid} value={item.siteid}> {item.site} ({item.siteid})</option>
									)
								})}

							</select>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Scheme:</div>
						<div className='row50'>
							<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "quote_scheme_id") ? undefined : 'error'} value={getFormValueWithId(ifid, "quote_scheme_id")} name='quote_scheme_id' onChange={(e) => doFormOnChange(e)}>
								<option value=''>Please Select...</option>

								{(filteredSchemes || []).map((item: User.schemesState) => {
									return (
										<option key={item.schemeid} value={item.schemeid}> {item.scheme} ({item.schemeid})</option>
									)
								})}

							</select>
						</div>
					</div>

					{filteredDevelopers.length > 0 &&
						<div style={{ display: 'flex', margin: 4 }}>
							<div className='row50'>Developer:</div>
							<div className='row50'>
								<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "quote_developer_id") ? undefined : 'error'} value={getFormValueWithId(ifid, "quote_developer_id")} name='quote_developer_id' onChange={(e) => doFormOnChange(e)}>
									<option value=''>Please Select...</option>

									{(filteredDevelopers || []).map((item: User.developerState) => {
										return (
											<option key={item.developerid} value={item.developerid}> {item.developer} ({item.developerid})</option>
										)
									})}

								</select>
							</div>
						</div>
					}

					{getFormValueWithId(ifid, "quote_property_type") === "new_build" &&
						<div>
							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>
									<label htmlFor='nb_plot_number'>Plot No:</label>
								</div>
								<div className='row50'>
									<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "nb_plot_number") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "nb_plot_number")} name='nb_plot_number' id='nb_plot_number' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>

							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>
									<label htmlFor='nb_reservation_date'>Reservation Date:</label>
								</div>
								<div className='row50'>
									<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "nb_reservation_date") ? undefined : 'error'} type='date' value={getFormValueWithId(ifid, "nb_reservation_date")} name='nb_reservation_date' id='nb_reservation_date' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>

							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>
									<label htmlFor='nb_reservation_date'>Expiry Date:</label>
								</div>
								<div className='row50'>
									<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "nb_expiry") ? undefined : 'error'} type='date' value={getFormValueWithId(ifid, "nb_expiry")} name='nb_expiry' id='nb_expiry' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>
						</div>
					}

					{getFormValueWithId(ifid, "quote_property_type") === "standard" &&
						<div>
							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>
									<label htmlFor='property_address_house'>House No./Name:</label>
								</div>
								<div className='row50'>
									<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "property_address_house") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "property_address_house")} name='property_address_house' id='property_address_house' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>

							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>
									<label htmlFor='property_address_street'>Street:</label>
								</div>
								<div className='row50'>
									<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "property_address_street") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "property_address_street")} name='property_address_street' id='property_address_street' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>

							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>
									<label htmlFor='property_address_town'>Town:</label>
								</div>
								<div className='row50'>
									<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "property_address_town") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "property_address_town")} name='property_address_town' id='property_address_town' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>

							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>
									<label htmlFor='property_address_county'>County:</label>
								</div>
								<div className='row50'>
									<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "property_address_county")} name='property_address_county' id='property_address_county' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>

							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>
									<label htmlFor='property_address_postcode'>Postcode:</label>
								</div>
								<div className='row50'>
									<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "property_address_postcode") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "property_address_postcode")} name='property_address_postcode' id='property_address_postcode' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>

							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'></div>
								<div className='row50'>
									<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'property_address')}>
										<div style={{ display: 'flex' }}>
											<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
											<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
										</div>
										{forms.isGettingAddress['property_address'] &&
											<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
										}
									</div>
								</div>
							</div>

							{getAddressListWithId('property_address').length > 0 &&
								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Select Address:</div>
									<div className='row50'>
										<select data-form-id={ifid} value={getFormValueWithId(ifid, "property_address")} name='property_address' onChange={(e) => selectAddress(e)}>
											<option value=''>Please Select...</option>
											{getAddressListWithId('property_address').map((item: Forms.postcodeAddressState, index: number) => {
												return (
													<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
												)
											})}
										</select>
									</div>
								</div>
							}
						</div>
					}

					<div className="main_rule"></div>
					<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Client Details</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>How many Clients?</div>
						<div className='row50'>
							<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "quote_nclients") ? undefined : 'error'} value={getFormValueWithId(ifid, "quote_nclients")} name='quote_nclients' onChange={(e) => doFormOnChange(e)}>
								<option value=''>Please Select...</option>
								<option value='1'>1</option>
								<option value='2'>2</option>
								<option value='3'>3</option>
								<option value='4'>4</option>
							</select>
						</div>
					</div>

					{parseInt(getFormValueWithId(ifid, "quote_nclients")) > 0 &&
						<div>
							<div className="main_rule"></div>
							<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Buyer 1 Details</div>

							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>Is this a Company or an Individual?</div>
								<div className='row50'>
									<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_comp_or_ind") ? undefined : 'error'} value={getFormValueWithId(ifid, "c1_comp_or_ind")} name='c1_comp_or_ind' onChange={(e) => doFormOnChange(e)}>
										<option value=''>Please Select...</option>
										<option value='0'>Individual</option>
										<option value='1'>Company</option>
									</select>
								</div>
							</div>

							{getFormValueWithId(ifid, "c1_comp_or_ind") === "0" &&
								<div>
									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Client 1 Details</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Title:</div>
										<div className='row50'>
											<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_title") ? undefined : 'error'} value={getFormValueWithId(ifid, "c1_title")} name='c1_title' onChange={(e) => doFormOnChange(e)}>
												<option value=''>Please Select...</option>
												<option value='Miss'>Miss</option>
												<option value='Ms'>Ms</option>
												<option value='Mrs'>Mrs</option>
												<option value='Mr'>Mr</option>
												<option value='Dr'>Dr</option>
												<option value='Other'>Other</option>
											</select>
										</div>
									</div>

									{getFormValueWithId(ifid, "c1_title") === "Other" &&
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_title_specify'>Please Specify:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_title_specify") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_title_specify")} name='c1_title_specify' id='c1_title_specify' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>
									}

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_firstname'>First Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_firstname") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_firstname")} name='c1_firstname' id='c1_firstname' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_middlenames'>Middle Names:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c1_middlenames")} name='c1_middlenames' id='c1_middlenames' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_surname'>Surname:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_surname") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_surname")} name='c1_surname' id='c1_surname' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_email'>Email Address:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="email" data-valid-message='Please enter a valid Email address' className={getFormValidWithId(ifid, "c1_email") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_email")} name='c1_email' id='c1_email' onChange={(e) => doFormOnChange(e)} />
											{!getFormValidWithId(ifid, 'c1_email') &&
												<div style={{ color: 'red' }}>{getFormMessageWithId(ifid, 'c1_email')}</div>
											}
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_main_number'>Home Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c1_main_number")} name='c1_main_number' id='c1_main_number' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_mobile_number'>Mobile Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_mobile_number") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_mobile_number")} name='c1_mobile_number' id='c1_mobile_number' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<div style={{ display: 'flex', flexDirection: 'column' }}>
												<div>Is Client 1 a UK Resident?</div>
												<div style={{ fontSize: 12 }}>For more information please click <a href="https://www.gov.uk/government/publications/rdr3-statutory-residence-test-srt" target="_blank">here</a></div>
											</div>
										</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c1_uk_resident") ? undefined : 'error'} type='radio' value='1' id="c1_uk_resident_yes" name='c1_uk_resident' checked={getFormValueWithId(ifid, "c1_uk_resident") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c1_uk_resident_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c1_uk_resident") ? undefined : 'error'} type='radio' value='2' id="c1_uk_resident_no" name='c1_uk_resident' checked={getFormValueWithId(ifid, "c1_uk_resident") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c1_uk_resident_no">No</label>
												</div>
											</div>
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50' style={{ fontFamily: 'OpenSans-Bold' }}>Client 1 Home Address</div>
										<div className='row50'>
											{getFormValueWithId(ifid, "quote_property_type") === "standard" &&
												<div style={{ display: 'flex', alignItems: 'center' }}>
													<div style={{ padding: 8 }}>
														<input data-form-id={ifid} type="checkbox" checked={getFormValueWithId(ifid, "c1_ind_addr_pop") === 'true'} name="c1_ind_addr_pop" id="c1_ind_addr_pop" onChange={(e) => doFormOnChange(e)} />
													</div>
													<div>
														<label htmlFor='c1_ind_addr_pop'>Use Property Address</label>
													</div>
												</div>
											}
										</div>
									</div>

									{(getFormValueWithId(ifid, "c1_ind_addr_pop") === 'false' || getFormValueWithId(ifid, "c1_ind_addr_pop") === '') &&
										<div>
											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c1_home_address_house'>House No./Name:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_home_address_house") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_home_address_house")} name='c1_home_address_house' id='c1_home_address_house' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c1_home_address_street'>Street:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_home_address_street") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_home_address_street")} name='c1_home_address_street' id='c1_home_address_street' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c1_home_address_town'>Town:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_home_address_town") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_home_address_town")} name='c1_home_address_town' id='c1_home_address_town' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c1_home_address_county'>County:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c1_home_address_county")} name='c1_home_address_county' id='c1_home_address_county' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c1_home_address_postcode'>Postcode:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_home_address_postcode") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_home_address_postcode")} name='c1_home_address_postcode' id='c1_home_address_postcode' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'></div>
												<div className='row50'>
													<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c1_home_address')}>
														<div style={{ display: 'flex' }}>
															<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
															<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
														</div>
														{forms.isGettingAddress['c1_home_address'] &&
															<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
														}
													</div>
												</div>
											</div>

											{getAddressListWithId('c1_home_address').length > 0 &&
												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>Select Address:</div>
													<div className='row50'>
														<select data-form-id={ifid} value={getFormValueWithId(ifid, "c1_home_address")} name='c1_home_address' onChange={(e) => selectAddress(e)}>
															<option value=''>Please Select...</option>
															{getAddressListWithId('c1_home_address').map((item: Forms.postcodeAddressState, index: number) => {
																return (
																	<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
																)
															})}
														</select>
													</div>
												</div>
											}
										</div>
									}
								</div>
							}

							{getFormValueWithId(ifid, "c1_comp_or_ind") === "1" &&
								<div>
									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Company Details</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_company_name'>Company Full Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_name") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_company_name")} name='c1_company_name' id='c1_company_name' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_company_number'>Company Number:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_number") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_company_number")} name='c1_company_number' id='c1_company_number' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_contact1_name'>Contact Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_contact1_name") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_contact1_name")} name='c1_contact1_name' id='c1_contact1_name' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_contact1_email'>Contact Email Address:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="email" className={getFormValidWithId(ifid, "c1_contact1_email") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_contact1_email")} name='c1_contact1_email' id='c1_contact1_email' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_contact1_mobile'>Contact Mobile Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_contact1_mobile") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_contact1_mobile")} name='c1_contact1_mobile' id='c1_contact1_mobile' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Registered Office Address</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_company_property'>Property No./Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_property") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_company_property")} name='c1_company_property' id='c1_company_property' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_company_street'>Street:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_street") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_company_street")} name='c1_company_street' id='c1_company_street' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_company_town'>Town:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_town") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_company_town")} name='c1_company_town' id='c1_company_town' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_company_county'>County:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c1_company_county")} name='c1_company_county' id='c1_company_county' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c1_company_postcode'>Postcode:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_postcode") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c1_company_postcode")} name='c1_company_postcode' id='c1_company_postcode' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'></div>
										<div className='row50'>
											<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c1_company')}>
												<div style={{ display: 'flex' }}>
													<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
													<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
												</div>
												{forms.isGettingAddress['c1_company'] &&
													<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
												}
											</div>
										</div>
									</div>

									{getAddressListWithId('c1_company').length > 0 &&
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>Select Address:</div>
											<div className='row50'>
												<select data-form-id={ifid} value={getFormValueWithId(ifid, "c1_company")} name='c1_company' onChange={(e) => selectAddress(e)}>
													<option value=''>Please Select...</option>
													{getAddressListWithId('c1_company').map((item: Forms.postcodeAddressState, index: number) => {
														return (
															<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
														)
													})}
												</select>
											</div>
										</div>
									}

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Is this company Registered in the UK?</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c1_uk_registered") ? undefined : 'error'} type='radio' value='1' id="c1_uk_registered_yes" name='c1_uk_registered' checked={getFormValueWithId(ifid, "c1_uk_registered") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c1_uk_registered_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c1_uk_registered") ? undefined : 'error'} type='radio' value='2' id="c1_uk_registered_no" name='c1_uk_registered' checked={getFormValueWithId(ifid, "c1_uk_registered") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c1_uk_registered_no">No</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							}
						</div>
					}

					{parseInt(getFormValueWithId(ifid, "quote_nclients")) > 1 &&
						<div>
							<div className="main_rule"></div>
							<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Buyer 2 Details</div>

							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>Is this a Company or an Individual?</div>
								<div className='row50'>
									<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_comp_or_ind") ? undefined : 'error'} value={getFormValueWithId(ifid, "c2_comp_or_ind")} name='c2_comp_or_ind' onChange={(e) => doFormOnChange(e)}>
										<option value=''>Please Select...</option>
										<option value='0'>Individual</option>
										<option value='1'>Company</option>
									</select>
								</div>
							</div>

							{getFormValueWithId(ifid, "c2_comp_or_ind") === "0" &&
								<div>
									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Client 2 Details</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Title:</div>
										<div className='row50'>
											<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_title") ? undefined : 'error'} value={getFormValueWithId(ifid, "c2_title")} name='c2_title' onChange={(e) => doFormOnChange(e)}>
												<option value=''>Please Select...</option>
												<option value='Miss'>Miss</option>
												<option value='Ms'>Ms</option>
												<option value='Mrs'>Mrs</option>
												<option value='Mr'>Mr</option>
												<option value='Dr'>Dr</option>
												<option value='Other'>Other</option>
											</select>
										</div>
									</div>

									{getFormValueWithId(ifid, "c2_title") === "Other" &&
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c2_title_specify'>Please Specify:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_title_specify") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_title_specify")} name='c2_title_specify' id='c2_title_specify' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>
									}

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_firstname'>First Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_firstname") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_firstname")} name='c2_firstname' id='c2_firstname' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_middlenames'>Middle Names:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c2_middlenames")} name='c2_middlenames' id='c2_middlenames' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_surname'>Surname:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_surname") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_surname")} name='c2_surname' id='c2_surname' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_email'>Email Address:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="email" data-valid-message='Please enter a valid Email address' data-valid-unique='["c1_email"]' data-unique-message='Email address must be unique to this Client' className={getFormValidWithId(ifid, "c2_email") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_email")} name='c2_email' id='c2_email' onChange={(e) => doFormOnChange(e)} />
											{!getFormValidWithId(ifid, 'c2_email') &&
												<div style={{ color: 'red' }}>{getFormMessageWithId(ifid, 'c2_email')}</div>
											}
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_main_number'>Home Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c2_main_number")} name='c2_main_number' id='c2_main_number' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_mobile_number'>Mobile Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" data-valid-unique='["c1_mobile_number"]' data-unique-message='Mobile number must be unique to this Client' className={getFormValidWithId(ifid, "c2_mobile_number") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_mobile_number")} name='c2_mobile_number' id='c2_mobile_number' onChange={(e) => doFormOnChange(e)} />
											{!getFormValidWithId(ifid, 'c2_mobile_number') &&
												<div style={{ color: 'red' }}>{getFormMessageWithId(ifid, 'c2_mobile_number')}</div>
											}
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<div style={{ display: 'flex', flexDirection: 'column' }}>
												<div>Is Client 2 a UK Resident?</div>
												<div style={{ fontSize: 12 }}>For more information please click <a href="https://www.gov.uk/government/publications/rdr3-statutory-residence-test-srt" target="_blank">here</a></div>
											</div>
										</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c2_uk_resident") ? undefined : 'error'} type='radio' value='1' id="c2_uk_resident_yes" name='c2_uk_resident' checked={getFormValueWithId(ifid, "c2_uk_resident") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c2_uk_resident_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c2_uk_resident") ? undefined : 'error'} type='radio' value='2' id="c2_uk_resident_no" name='c2_uk_resident' checked={getFormValueWithId(ifid, "c2_uk_resident") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c2_uk_resident_no">No</label>
												</div>
											</div>
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50' style={{ fontFamily: 'OpenSans-Bold' }}>Client 2 Home Address</div>
										<div className='row50'>
											{getFormValueWithId(ifid, "quote_property_type") === "standard" &&
												<div style={{ display: 'flex', alignItems: 'center' }}>
													<div style={{ padding: 8 }}>
														<input data-form-id={ifid} type="checkbox" checked={getFormValueWithId(ifid, "c2_ind_addr_pop") === 'true'} name="c2_ind_addr_pop" id="c2_ind_addr_pop" onChange={(e) => doFormOnChange(e)} />
													</div>
													<div>
														<label htmlFor='c2_ind_addr_pop'>Use Property Address</label>
													</div>
												</div>
											}
										</div>
									</div>

									{(getFormValueWithId(ifid, "c2_ind_addr_pop") === 'false' || getFormValueWithId(ifid, "c2_ind_addr_pop") === '') &&
										<div>
											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c2_home_address_house'>House No./Name:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_home_address_house") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_home_address_house")} name='c2_home_address_house' id='c2_home_address_house' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c2_home_address_street'>Street:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_home_address_street") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_home_address_street")} name='c2_home_address_street' id='c2_home_address_street' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c2_home_address_town'>Town:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_home_address_town") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_home_address_town")} name='c2_home_address_town' id='c2_home_address_town' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c2_home_address_county'>County:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c2_home_address_county")} name='c2_home_address_county' id='c2_home_address_county' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c2_home_address_postcode'>Postcode:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_home_address_postcode") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_home_address_postcode")} name='c2_home_address_postcode' id='c2_home_address_postcode' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'></div>
												<div className='row50'>
													<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c2_home_address')}>
														<div style={{ display: 'flex' }}>
															<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
															<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
														</div>
														{forms.isGettingAddress['c2_home_address'] &&
															<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
														}
													</div>
												</div>
											</div>

											{getAddressListWithId('c2_home_address').length > 0 &&
												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>Select Address:</div>
													<div className='row50'>
														<select data-form-id={ifid} value={getFormValueWithId(ifid, "c2_home_address")} name='c2_home_address' onChange={(e) => selectAddress(e)}>
															<option value=''>Please Select...</option>
															{getAddressListWithId('c2_home_address').map((item: Forms.postcodeAddressState, index: number) => {
																return (
																	<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
																)
															})}
														</select>
													</div>
												</div>
											}
										</div>
									}
								</div>
							}

							{getFormValueWithId(ifid, "c2_comp_or_ind") === "1" &&
								<div>
									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Company Details</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_company_name'>Company Full Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_name") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_company_name")} name='c2_company_name' id='c2_company_name' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_company_number'>Company Number:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_number") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_company_number")} name='c2_company_number' id='c2_company_number' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_contact1_name'>Contact Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_contact1_name") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_contact1_name")} name='c2_contact1_name' id='c2_contact1_name' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_contact1_email'>Contact Email Address:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="email" className={getFormValidWithId(ifid, "c2_contact1_email") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_contact1_email")} name='c2_contact1_email' id='c2_contact1_email' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_contact1_mobile'>Contact Mobile Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_contact1_mobile") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_contact1_mobile")} name='c2_contact1_mobile' id='c2_contact1_mobile' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Registered Office Address</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_company_property'>Property No./Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_property") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_company_property")} name='c2_company_property' id='c2_company_property' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_company_street'>Street:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_street") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_company_street")} name='c2_company_street' id='c2_company_street' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_company_town'>Town:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_town") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_company_town")} name='c2_company_town' id='c2_company_town' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_company_county'>County:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c2_company_county")} name='c2_company_county' id='c2_company_county' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c2_company_postcode'>Postcode:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_postcode") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c2_company_postcode")} name='c2_company_postcode' id='c2_company_postcode' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'></div>
										<div className='row50'>
											<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c2_company')}>
												<div style={{ display: 'flex' }}>
													<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
													<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
												</div>
												{forms.isGettingAddress['c2_company'] &&
													<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
												}
											</div>
										</div>
									</div>

									{getAddressListWithId('c2_company').length > 0 &&
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>Select Address:</div>
											<div className='row50'>
												<select data-form-id={ifid} value={getFormValueWithId(ifid, "c2_company")} name='c2_company' onChange={(e) => selectAddress(e)}>
													<option value=''>Please Select...</option>
													{getAddressListWithId('c2_company').map((item: Forms.postcodeAddressState, index: number) => {
														return (
															<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
														)
													})}
												</select>
											</div>
										</div>
									}

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Is this company Registered in the UK?</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c2_uk_registered") ? undefined : 'error'} type='radio' value='1' id="c2_uk_registered_yes" name='c2_uk_registered' checked={getFormValueWithId(ifid, "c2_uk_registered") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c2_uk_registered_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c2_uk_registered") ? undefined : 'error'} type='radio' value='2' id="c2_uk_registered_no" name='c2_uk_registered' checked={getFormValueWithId(ifid, "c2_uk_registered") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c2_uk_registered_no">No</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							}
						</div>
					}

					{parseInt(getFormValueWithId(ifid, "quote_nclients")) > 2 &&
						<div>
							<div className="main_rule"></div>
							<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Buyer 3 Details</div>

							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>Is this a Company or an Individual?</div>
								<div className='row50'>
									<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_comp_or_ind") ? undefined : 'error'} value={getFormValueWithId(ifid, "c3_comp_or_ind")} name='c3_comp_or_ind' onChange={(e) => doFormOnChange(e)}>
										<option value=''>Please Select...</option>
										<option value='0'>Individual</option>
										<option value='1'>Company</option>
									</select>
								</div>
							</div>

							{getFormValueWithId(ifid, "c3_comp_or_ind") === "0" &&
								<div>
									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Client 3 Details</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Title:</div>
										<div className='row50'>
											<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_title") ? undefined : 'error'} value={getFormValueWithId(ifid, "c3_title")} name='c3_title' onChange={(e) => doFormOnChange(e)}>
												<option value=''>Please Select...</option>
												<option value='Miss'>Miss</option>
												<option value='Ms'>Ms</option>
												<option value='Mrs'>Mrs</option>
												<option value='Mr'>Mr</option>
												<option value='Dr'>Dr</option>
												<option value='Other'>Other</option>
											</select>
										</div>
									</div>

									{getFormValueWithId(ifid, "c3_title") === "Other" &&
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c3_title_specify'>Please Specify:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_title_specify") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_title_specify")} name='c3_title_specify' id='c3_title_specify' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>
									}

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_firstname'>First Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_firstname") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_firstname")} name='c3_firstname' id='c3_firstname' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_middlenames'>Middle Names:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c3_middlenames")} name='c3_middlenames' id='c3_middlenames' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_surname'>Surname:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_surname") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_surname")} name='c3_surname' id='c3_surname' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_email'>Email Address:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="email" data-valid-message='Please enter a valid Email address' data-valid-unique='["c1_email","c2_email"]' data-unique-message='Email address must be unique to this Client' className={getFormValidWithId(ifid, "c3_email") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_email")} name='c3_email' id='c3_email' onChange={(e) => doFormOnChange(e)} />
											{!getFormValidWithId(ifid, 'c3_email') &&
												<div style={{ color: 'red' }}>{getFormMessageWithId(ifid, 'c3_email')}</div>
											}
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_main_number'>Home Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c3_main_number")} name='c3_main_number' id='c3_main_number' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_mobile_number'>Mobile Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" data-valid-unique='["c1_mobile_number","c2_mobile_number"]' data-unique-message='Mobile number must be unique to this Client' className={getFormValidWithId(ifid, "c3_mobile_number") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_mobile_number")} name='c3_mobile_number' id='c3_mobile_number' onChange={(e) => doFormOnChange(e)} />
											{!getFormValidWithId(ifid, 'c3_mobile_number') &&
												<div style={{ color: 'red' }}>{getFormMessageWithId(ifid, 'c3_mobile_number')}</div>
											}
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<div style={{ display: 'flex', flexDirection: 'column' }}>
												<div>Is Client 3 a UK Resident?</div>
												<div style={{ fontSize: 12 }}>For more information please click <a href="https://www.gov.uk/government/publications/rdr3-statutory-residence-test-srt" target="_blank">here</a></div>
											</div>
										</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c3_uk_resident") ? undefined : 'error'} type='radio' value='1' id="c3_uk_resident_yes" name='c3_uk_resident' checked={getFormValueWithId(ifid, "c3_uk_resident") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c3_uk_resident_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c3_uk_resident") ? undefined : 'error'} type='radio' value='2' id="c3_uk_resident_no" name='c3_uk_resident' checked={getFormValueWithId(ifid, "c3_uk_resident") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c3_uk_resident_no">No</label>
												</div>
											</div>
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50' style={{ fontFamily: 'OpenSans-Bold' }}>Client 3 Home Address</div>
										<div className='row50'>
											{getFormValueWithId(ifid, "quote_property_type") === "standard" &&
												<div style={{ display: 'flex', alignItems: 'center' }}>
													<div style={{ padding: 8 }}>
														<input data-form-id={ifid} type="checkbox" checked={getFormValueWithId(ifid, "c3_ind_addr_pop") === 'true'} name="c3_ind_addr_pop" id="c3_ind_addr_pop" onChange={(e) => doFormOnChange(e)} />
													</div>
													<div>
														<label htmlFor='c3_ind_addr_pop'>Use Property Address</label>
													</div>
												</div>
											}
										</div>
									</div>

									{(getFormValueWithId(ifid, "c3_ind_addr_pop") === 'false' || getFormValueWithId(ifid, "c3_ind_addr_pop") === '') &&
										<div>
											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c3_home_address_house'>House No./Name:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_home_address_house") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_home_address_house")} name='c3_home_address_house' id='c3_home_address_house' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c3_home_address_street'>Street:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_home_address_street") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_home_address_street")} name='c3_home_address_street' id='c3_home_address_street' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c3_home_address_town'>Town:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_home_address_town") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_home_address_town")} name='c3_home_address_town' id='c3_home_address_town' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c3_home_address_county'>County:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c3_home_address_county")} name='c3_home_address_county' id='c3_home_address_county' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c3_home_address_postcode'>Postcode:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_home_address_postcode") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_home_address_postcode")} name='c3_home_address_postcode' id='c3_home_address_postcode' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'></div>
												<div className='row50'>
													<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c3_home_address')}>
														<div style={{ display: 'flex' }}>
															<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
															<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
														</div>
														{forms.isGettingAddress['c3_home_address'] &&
															<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
														}
													</div>
												</div>
											</div>

											{getAddressListWithId('c3_home_address').length > 0 &&
												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>Select Address:</div>
													<div className='row50'>
														<select data-form-id={ifid} value={getFormValueWithId(ifid, "c3_home_address")} name='c3_home_address' onChange={(e) => selectAddress(e)}>
															<option value=''>Please Select...</option>
															{getAddressListWithId('c3_home_address').map((item: Forms.postcodeAddressState, index: number) => {
																return (
																	<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
																)
															})}
														</select>
													</div>
												</div>
											}
										</div>
									}
								</div>
							}

							{getFormValueWithId(ifid, "c3_comp_or_ind") === "1" &&
								<div>
									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Company Details</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_company_name'>Company Full Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_name") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_company_name")} name='c3_company_name' id='c3_company_name' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_company_number'>Company Number:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_number") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_company_number")} name='c3_company_number' id='c3_company_number' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_contact1_name'>Contact Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_contact1_name") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_contact1_name")} name='c3_contact1_name' id='c3_contact1_name' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_contact1_email'>Contact Email Address:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="email" className={getFormValidWithId(ifid, "c3_contact1_email") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_contact1_email")} name='c3_contact1_email' id='c3_contact1_email' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_contact1_mobile'>Contact Mobile Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_contact1_mobile") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_contact1_mobile")} name='c3_contact1_mobile' id='c3_contact1_mobile' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Registered Office Address</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_company_property'>Property No./Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_property") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_company_property")} name='c3_company_property' id='c3_company_property' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_company_street'>Street:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_street") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_company_street")} name='c3_company_street' id='c3_company_street' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_company_town'>Town:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_town") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_company_town")} name='c3_company_town' id='c3_company_town' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_company_county'>County:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c3_company_county")} name='c3_company_county' id='c3_company_county' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c3_company_postcode'>Postcode:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_postcode") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c3_company_postcode")} name='c3_company_postcode' id='c3_company_postcode' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'></div>
										<div className='row50'>
											<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c3_company')}>
												<div style={{ display: 'flex' }}>
													<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
													<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
												</div>
												{forms.isGettingAddress['c3_company'] &&
													<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
												}
											</div>
										</div>
									</div>

									{getAddressListWithId('c3_company').length > 0 &&
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>Select Address:</div>
											<div className='row50'>
												<select data-form-id={ifid} value={getFormValueWithId(ifid, "c3_company")} name='c3_company' onChange={(e) => selectAddress(e)}>
													<option value=''>Please Select...</option>
													{getAddressListWithId('c3_company').map((item: Forms.postcodeAddressState, index: number) => {
														return (
															<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
														)
													})}
												</select>
											</div>
										</div>
									}

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Is this company Registered in the UK?</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c3_uk_registered") ? undefined : 'error'} type='radio' value='1' id="c3_uk_registered_yes" name='c3_uk_registered' checked={getFormValueWithId(ifid, "c3_uk_registered") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c3_uk_registered_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c3_uk_registered") ? undefined : 'error'} type='radio' value='2' id="c3_uk_registered_no" name='c3_uk_registered' checked={getFormValueWithId(ifid, "c3_uk_registered") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c3_uk_registered_no">No</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							}
						</div>
					}

					{parseInt(getFormValueWithId(ifid, "quote_nclients")) > 3 &&
						<div>
							<div className="main_rule"></div>
							<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Buyer 4 Details</div>

							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row50'>Is this a Company or an Individual?</div>
								<div className='row50'>
									<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_comp_or_ind") ? undefined : 'error'} value={getFormValueWithId(ifid, "c4_comp_or_ind")} name='c4_comp_or_ind' onChange={(e) => doFormOnChange(e)}>
										<option value=''>Please Select...</option>
										<option value='0'>Individual</option>
										<option value='1'>Company</option>
									</select>
								</div>
							</div>

							{getFormValueWithId(ifid, "c4_comp_or_ind") === "0" &&
								<div>
									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Client 4 Details</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Title:</div>
										<div className='row50'>
											<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_title") ? undefined : 'error'} value={getFormValueWithId(ifid, "c4_title")} name='c4_title' onChange={(e) => doFormOnChange(e)}>
												<option value=''>Please Select...</option>
												<option value='Miss'>Miss</option>
												<option value='Ms'>Ms</option>
												<option value='Mrs'>Mrs</option>
												<option value='Mr'>Mr</option>
												<option value='Dr'>Dr</option>
												<option value='Other'>Other</option>
											</select>
										</div>
									</div>

									{getFormValueWithId(ifid, "c4_title") === "Other" &&
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c4_title_specify'>Please Specify:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_title_specify") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_title_specify")} name='c4_title_specify' id='c4_title_specify' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>
									}

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_firstname'>First Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_firstname") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_firstname")} name='c4_firstname' id='c4_firstname' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_middlenames'>Middle Names:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c4_middlenames")} name='c4_middlenames' id='c4_middlenames' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_surname'>Surname:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_surname") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_surname")} name='c4_surname' id='c4_surname' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_email'>Email Address:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="email" data-valid-message='Please enter a valid Email address' data-valid-unique='["c1_email","c2_email","c3_email"]' data-unique-message='Email address must be unique to this Client' className={getFormValidWithId(ifid, "c4_email") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_email")} name='c4_email' id='c4_email' onChange={(e) => doFormOnChange(e)} />
											{!getFormValidWithId(ifid, 'c4_email') &&
												<div style={{ color: 'red' }}>{getFormMessageWithId(ifid, 'c4_email')}</div>
											}
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_main_number'>Home Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c4_main_number")} name='c4_main_number' id='c4_main_number' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_mobile_number'>Mobile Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" data-valid-unique='["c1_mobile_number","c2_mobile_number","c3_mobile_number"]' data-unique-message='Mobile number must be unique to this Client' className={getFormValidWithId(ifid, "c4_mobile_number") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_mobile_number")} name='c4_mobile_number' id='c4_mobile_number' onChange={(e) => doFormOnChange(e)} />
											{!getFormValidWithId(ifid, 'c4_mobile_number') &&
												<div style={{ color: 'red' }}>{getFormMessageWithId(ifid, 'c4_mobile_number')}</div>
											}
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<div style={{ display: 'flex', flexDirection: 'column' }}>
												<div>Is Client 4 a UK Resident?</div>
												<div style={{ fontSize: 12 }}>For more information please click <a href="https://www.gov.uk/government/publications/rdr3-statutory-residence-test-srt" target="_blank">here</a></div>
											</div>
										</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c4_uk_resident") ? undefined : 'error'} type='radio' value='1' id="c4_uk_resident_yes" name='c4_uk_resident' checked={getFormValueWithId(ifid, "c4_uk_resident") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c4_uk_resident_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c4_uk_resident") ? undefined : 'error'} type='radio' value='2' id="c4_uk_resident_no" name='c4_uk_resident' checked={getFormValueWithId(ifid, "c4_uk_resident") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c4_uk_resident_no">No</label>
												</div>
											</div>
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50' style={{ fontFamily: 'OpenSans-Bold' }}>Client 4 Home Address</div>
										<div className='row50'>
											{getFormValueWithId(ifid, "quote_property_type") === "standard" &&
												<div style={{ display: 'flex', alignItems: 'center' }}>
													<div style={{ padding: 8 }}>
														<input data-form-id={ifid} type="checkbox" checked={getFormValueWithId(ifid, "c4_ind_addr_pop") === 'true'} name="c4_ind_addr_pop" id="c4_ind_addr_pop" onChange={(e) => doFormOnChange(e)} />
													</div>
													<div>
														<label htmlFor='c4_ind_addr_pop'>Use Property Address</label>
													</div>
												</div>
											}
										</div>
									</div>

									{(getFormValueWithId(ifid, "c4_ind_addr_pop") === 'false' || getFormValueWithId(ifid, "c4_ind_addr_pop") === '') &&
										<div>
											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c4_home_address_house'>House No./Name:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_home_address_house") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_home_address_house")} name='c4_home_address_house' id='c4_home_address_house' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c4_home_address_street'>Street:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_home_address_street") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_home_address_street")} name='c4_home_address_street' id='c4_home_address_street' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c4_home_address_town'>Town:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_home_address_town") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_home_address_town")} name='c4_home_address_town' id='c4_home_address_town' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c4_home_address_county'>County:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c4_home_address_county")} name='c4_home_address_county' id='c4_home_address_county' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c4_home_address_postcode'>Postcode:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_home_address_postcode") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_home_address_postcode")} name='c4_home_address_postcode' id='c4_home_address_postcode' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>

											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'></div>
												<div className='row50'>
													<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c4_home_address')}>
														<div style={{ display: 'flex' }}>
															<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
															<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
														</div>
														{forms.isGettingAddress['c4_home_address'] &&
															<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
														}
													</div>
												</div>
											</div>

											{getAddressListWithId('c4_home_address').length > 0 &&
												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>Select Address:</div>
													<div className='row50'>
														<select data-form-id={ifid} value={getFormValueWithId(ifid, "c4_home_address")} name='c4_home_address' onChange={(e) => selectAddress(e)}>
															<option value=''>Please Select...</option>
															{getAddressListWithId('c4_home_address').map((item: Forms.postcodeAddressState, index: number) => {
																return (
																	<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
																)
															})}
														</select>
													</div>
												</div>
											}
										</div>
									}
								</div>
							}

							{getFormValueWithId(ifid, "c4_comp_or_ind") === "1" &&
								<div>
									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Company Details</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_company_name'>Company Full Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_name") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_company_name")} name='c4_company_name' id='c4_company_name' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_company_number'>Company Number:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_number") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_company_number")} name='c4_company_number' id='c4_company_number' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_contact1_name'>Contact Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_contact1_name") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_contact1_name")} name='c4_contact1_name' id='c4_contact1_name' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_contact1_email'>Contact Email Address:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="email" className={getFormValidWithId(ifid, "c4_contact1_email") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_contact1_email")} name='c4_contact1_email' id='c4_contact1_email' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_contact1_mobile'>Contact Mobile Phone No:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_contact1_mobile") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_contact1_mobile")} name='c4_contact1_mobile' id='c4_contact1_mobile' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Registered Office Address</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_company_property'>Property No./Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_property") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_company_property")} name='c4_company_property' id='c4_company_property' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_company_street'>Street:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_street") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_company_street")} name='c4_company_street' id='c4_company_street' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_company_town'>Town:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_town") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_company_town")} name='c4_company_town' id='c4_company_town' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_company_county'>County:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} type='text' value={getFormValueWithId(ifid, "c4_company_county")} name='c4_company_county' id='c4_company_county' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='c4_company_postcode'>Postcode:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_postcode") ? undefined : 'error'} type='text' value={getFormValueWithId(ifid, "c4_company_postcode")} name='c4_company_postcode' id='c4_company_postcode' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'></div>
										<div className='row50'>
											<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c4_company')}>
												<div style={{ display: 'flex' }}>
													<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
													<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
												</div>
												{forms.isGettingAddress['c4_company'] &&
													<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
												}
											</div>
										</div>
									</div>

									{getAddressListWithId('c4_company').length > 0 &&
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>Select Address:</div>
											<div className='row50'>
												<select data-form-id={ifid} value={getFormValueWithId(ifid, "c4_company")} name='c4_company' onChange={(e) => selectAddress(e)}>
													<option value=''>Please Select...</option>
													{getAddressListWithId('c4_company').map((item: Forms.postcodeAddressState, index: number) => {
														return (
															<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
														)
													})}
												</select>
											</div>
										</div>
									}

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Is this company Registered in the UK?</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c4_uk_registered") ? undefined : 'error'} type='radio' value='1' id="c4_uk_registered_yes" name='c4_uk_registered' checked={getFormValueWithId(ifid, "c4_uk_registered") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c4_uk_registered_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={ifid} className={getFormValidWithId(ifid, "c4_uk_registered") ? undefined : 'error'} type='radio' value='2' id="c4_uk_registered_no" name='c4_uk_registered' checked={getFormValueWithId(ifid, "c4_uk_registered") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="c4_uk_registered_no">No</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							}
						</div>
					}
					<div className="main_rule"></div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Would you like PLS to draft a Declaration of Trust?</div>
						<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_declaration") ? undefined : 'error'} type='radio' value='1' id="quote_declaration_yes" name='quote_declaration' checked={getFormValueWithId(ifid, "quote_declaration") === '1'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_declaration_yes">Yes</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_declaration") ? undefined : 'error'} type='radio' value='2' id="quote_declaration_no" name='quote_declaration' checked={getFormValueWithId(ifid, "quote_declaration") === '2'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_declaration_no">No</label>
								</div>
							</div>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Is the property Freehold or Leasehold?</div>
						<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_hold") ? undefined : 'error'} type='radio' value='F' id="quote_hold_f" name='quote_hold' checked={getFormValueWithId(ifid, "quote_hold") === 'F'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_hold_f">Freehold</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_hold") ? undefined : 'error'} type='radio' value='L' id="quote_hold_l" name='quote_hold' checked={getFormValueWithId(ifid, "quote_hold") === 'L'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_hold_l">Leasehold</label>
								</div>
							</div>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Where is the Property located?</div>
						<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_location") ? undefined : 'error'} type='radio' value='01' id="quote_location_england" name='quote_location' checked={getFormValueWithId(ifid, "quote_location") === '01'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_location_england">England</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_location") ? undefined : 'error'} type='radio' value='02' id="quote_location_wales" name='quote_location' checked={getFormValueWithId(ifid, "quote_location") === '02'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_location_wales">Wales</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_location") ? undefined : 'error'} type='radio' value='03' id="quote_location_both" name='quote_location' checked={getFormValueWithId(ifid, "quote_location") === '03'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_location_both">Partly in Both</label>
								</div>
							</div>
						</div>
					</div>

					{getFormValueWithId(ifid, "quote_location") === "01" &&
						<div style={{ display: 'flex', margin: 4 }}>
							<div className='row50'>Is the Property located in London?</div>
							<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
								<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
									<div style={{ padding: 8 }}>
										<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_location_london") ? undefined : 'error'} type='radio' value='1' id="quote_location_london_yes" name='quote_location_london' checked={getFormValueWithId(ifid, "quote_location_london") === '1'} onChange={(e) => doFormOnChange(e)} />
									</div>
									<div className='flexGrow1'>
										<label htmlFor="quote_location_london_yes">Yes</label>
									</div>
								</div>
								<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
									<div style={{ padding: 8 }}>
										<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_location_london") ? undefined : 'error'} type='radio' value='2' id="quote_location_london_no" name='quote_location_london' checked={getFormValueWithId(ifid, "quote_location_london") === '2'} onChange={(e) => doFormOnChange(e)} />
									</div>
									<div className='flexGrow1'>
										<label htmlFor="quote_location_london_no">No</label>
									</div>
								</div>
							</div>
						</div>
					}

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>How are you funding this transaction?</div>
						<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_funding") ? undefined : 'error'} type='radio' value='001' id="quote_funding_cash" name='quote_funding' checked={getFormValueWithId(ifid, "quote_funding") === '001'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_funding_cash">Cash</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_funding") ? undefined : 'error'} type='radio' value='002' id="quote_funding_mortgage" name='quote_funding' checked={getFormValueWithId(ifid, "quote_funding") === '002'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_funding_mortgage">Mortgage</label>
								</div>
							</div>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Are you being provided with a gift to purchase the property?</div>
						<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_gift") ? undefined : 'error'} type='radio' value='1' id="quote_gift_yes" name='quote_gift' checked={getFormValueWithId(ifid, "quote_gift") === '1'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_gift_yes">Yes</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_gift") ? undefined : 'error'} type='radio' value='2' id="quote_gift_no" name='quote_gift' checked={getFormValueWithId(ifid, "quote_gift") === '2'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_gift_no">No</label>
								</div>
							</div>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Do you own more than one property?</div>
						<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_more") ? undefined : 'error'} type='radio' value='1' id="quote_more_yes" name='quote_more' checked={getFormValueWithId(ifid, "quote_more") === '1'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_more_yes">Yes</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_more") ? undefined : 'error'} type='radio' value='2' id="quote_more_no" name='quote_more' checked={getFormValueWithId(ifid, "quote_more") === '2'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_more_no">No</label>
								</div>
							</div>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Is this property going to be Buy to Let?</div>
						<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_buytolet") ? undefined : 'error'} type='radio' value='1' id="quote_buytolet_yes" name='quote_buytolet' checked={getFormValueWithId(ifid, "quote_buytolet") === '1'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_buytolet_yes">Yes</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_buytolet") ? undefined : 'error'} type='radio' value='2' id="quote_buytolet_no" name='quote_buytolet' checked={getFormValueWithId(ifid, "quote_buytolet") === '2'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_buytolet_no">No</label>
								</div>
							</div>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Are all the clients who are purchasing the property first time buyers?</div>
						<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_ftb") ? undefined : 'error'} type='radio' value='1' id="quote_ftb_yes" name='quote_ftb' checked={getFormValueWithId(ifid, "quote_ftb") === '1'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_ftb_yes">Yes</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_ftb") ? undefined : 'error'} type='radio' value='2' id="quote_ftb_no" name='quote_ftb' checked={getFormValueWithId(ifid, "quote_ftb") === '2'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_ftb_no">No</label>
								</div>
							</div>
						</div>
					</div>

					{parseInt(getFormValueWithId(ifid, "quote_property_price")) <= 600000 && getFormValueWithId(ifid, "quote_property_type") === "new_build" &&
						<div style={{ display: 'flex', margin: 4 }}>
							<div className='row50'>Are you using Government Help to Buy Scheme?</div>
							<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
								<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
									<div style={{ padding: 8 }}>
										<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_htb") ? undefined : 'error'} type='radio' value='1' id="quote_htb_yes" name='quote_htb' checked={getFormValueWithId(ifid, "quote_htb") === '1'} onChange={(e) => doFormOnChange(e)} />
									</div>
									<div className='flexGrow1'>
										<label htmlFor="quote_htb_yes">Yes</label>
									</div>
								</div>
								<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
									<div style={{ padding: 8 }}>
										<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_htb") ? undefined : 'error'} type='radio' value='2' id="quote_htb_no" name='quote_htb' checked={getFormValueWithId(ifid, "quote_htb") === '2'} onChange={(e) => doFormOnChange(e)} />
									</div>
									<div className='flexGrow1'>
										<label htmlFor="quote_htb_no">No</label>
									</div>
								</div>
							</div>
						</div>
					}

					{((parseInt(getFormValueWithId(ifid, "quote_property_price")) <= 250000 && getFormValueWithId(ifid, "quote_location_london") !== "1") || (parseInt(getFormValueWithId(ifid, "quote_property_price")) <= 450000 && getFormValueWithId(ifid, "quote_location_london") === "1")) &&
						<div style={{ display: 'flex', margin: 4 }}>
							<div className='row50'>Are you using Help to Buy ISA?</div>
							<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
								<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
									<div style={{ padding: 8 }}>
										<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_htbisa") ? undefined : 'error'} type='radio' value='1' id="quote_htbisa_yes" name='quote_htbisa' checked={getFormValueWithId(ifid, "quote_htbisa") === '1'} onChange={(e) => doFormOnChange(e)} />
									</div>
									<div className='flexGrow1'>
										<label htmlFor="quote_htbisa_yes">Yes</label>
									</div>
								</div>
								<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
									<div style={{ padding: 8 }}>
										<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_htbisa") ? undefined : 'error'} type='radio' value='2' id="quote_htbisa_no" name='quote_htbisa' checked={getFormValueWithId(ifid, "quote_htbisa") === '2'} onChange={(e) => doFormOnChange(e)} />
									</div>
									<div className='flexGrow1'>
										<label htmlFor="quote_htbisa_no">No</label>
									</div>
								</div>
							</div>
						</div>
					}

					{getFormValueWithId(ifid, "quote_htbisa") === "1" && ((parseInt(getFormValueWithId(ifid, "quote_property_price")) <= 250000 && getFormValueWithId(ifid, "quote_location_london") !== "1") || (parseInt(getFormValueWithId(ifid, "quote_property_price")) <= 450000 && getFormValueWithId(ifid, "quote_location_london") === "1")) &&
						<div style={{ display: 'flex', margin: 4 }}>
							<div className='row50'>How many Help to Buy ISA will be used?</div>
							<div className='row50'>
								<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "quote_htbisa_quantity") ? undefined : 'error'} type='number' value={getFormValueWithId(ifid, "quote_htbisa_quantity")} name='quote_htbisa_quantity' min='1' max={getFormValueWithId(ifid, "quote_nclients")} onChange={(e) => doFormOnChange(e)} />
							</div>
						</div>
					}

					{parseInt(getFormValueWithId(ifid, "quote_property_price")) <= 450000 &&
						<div style={{ display: 'flex', margin: 4 }}>
							<div className='row50'>Are you using a Lifetime ISA?</div>
							<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
								<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
									<div style={{ padding: 8 }}>
										<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_ltisa") ? undefined : 'error'} type='radio' value='1' id="quote_ltisa_yes" name='quote_ltisa' checked={getFormValueWithId(ifid, "quote_ltisa") === '1'} onChange={(e) => doFormOnChange(e)} />
									</div>
									<div className='flexGrow1'>
										<label htmlFor="quote_ltisa_yes">Yes</label>
									</div>
								</div>
								<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
									<div style={{ padding: 8 }}>
										<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_ltisa") ? undefined : 'error'} type='radio' value='2' id="quote_ltisa_no" name='quote_ltisa' checked={getFormValueWithId(ifid, "quote_ltisa") === '2'} onChange={(e) => doFormOnChange(e)} />
									</div>
									<div className='flexGrow1'>
										<label htmlFor="quote_ltisa_no">No</label>
									</div>
								</div>
							</div>
						</div>
					}

					{getFormValueWithId(ifid, "quote_ltisa") === "1" && parseInt(getFormValueWithId(ifid, "quote_property_price")) <= 450000 &&
						<div style={{ display: 'flex', margin: 4 }}>
							<div className='row50'>How many Lifetime ISA will be used?</div>
							<div className='row50'>
								<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "quote_ltisa_quantity") ? undefined : 'error'} type='number' value={getFormValueWithId(ifid, "quote_ltisa_quantity")} name='quote_ltisa_quantity' min='1' max={getFormValueWithId(ifid, "quote_nclients")} onChange={(e) => doFormOnChange(e)} />
							</div>
						</div>
					}

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Is this property a shared ownership scheme purchase?</div>
						<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_shared") ? undefined : 'error'} type='radio' value='1' id="quote_shared_yes" name='quote_shared' checked={getFormValueWithId(ifid, "quote_shared") === '1'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_shared_yes">Yes</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_shared") ? undefined : 'error'} type='radio' value='2' id="quote_shared_no" name='quote_shared' checked={getFormValueWithId(ifid, "quote_shared") === '2'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_shared_no">No</label>
								</div>
							</div>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Are you based overseas?</div>
						<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_overseas") ? undefined : 'error'} type='radio' value='1' id="quote_overseas_yes" name='quote_overseas' checked={getFormValueWithId(ifid, "quote_overseas") === '1'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_overseas_yes">Yes</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_overseas") ? undefined : 'error'} type='radio' value='2' id="quote_overseas_no" name='quote_overseas' checked={getFormValueWithId(ifid, "quote_overseas") === '2'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_overseas_no">No</label>
								</div>
							</div>
						</div>
					</div>

					<div style={{ display: 'flex', margin: 4 }}>
						<div className='row50'>Are all the clients UK Residents, or registered to the UK if a company?</div>
						<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_uk_resident") ? undefined : 'error'} type='radio' value='1' id="quote_uk_resident_yes" name='quote_uk_resident' checked={getFormValueWithId(ifid, "quote_uk_resident") === '1'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_uk_resident_yes">Yes</label>
								</div>
							</div>
							<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ padding: 8 }}>
									<input data-form-id={ifid} className={getFormValidWithId(ifid, "quote_uk_resident") ? undefined : 'error'} type='radio' value='2' id="quote_uk_resident_no" name='quote_uk_resident' checked={getFormValueWithId(ifid, "quote_uk_resident") === '2'} onChange={(e) => doFormOnChange(e)} />
								</div>
								<div className='flexGrow1'>
									<label htmlFor="quote_uk_resident_no">No</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default InstructPurchase;